import Vue from 'vue';

Vue.component('best-seller-index', () =>
    import(/* webpackChunkName: 'best-seller-index' */ './best-seller-index.vue'),
);
